<template>
  <div class="date-com">
      <div class="over-hide">
        <p :class="['day', {show: showText}]" data-lang="星期">{{ DAY }}</p>
      </div>
      <div class="date-decorate"></div>
      <div class="over-hide">
        <p :class="['date', {show: showText}]" data-lang="月日">{{ Month || '' }}{{ util.dateParse(Date.now(), 'dd') }}</p>
      </div>
  </div>
</template>

<script>
// 日期组件
export default {
    name: 'dateCom',
    data() {
        return {
            showText: false
        }
    },
    computed: {
        DAY() {
            let date = this.util.dateParse(Date.now(), 'E'),
                Day = ''
            switch (date) {
                case '7': 
                    Day = 'Sunday'
                    break;
                case '1': 
                    Day = 'Monday'
                    break;
                case '2': 
                    Day = 'Tuesday'
                    break;
                case '3': 
                    Day = 'Wednesday'
                    break;
                case '4': 
                    Day = 'Thursday'
                    break;
                case '5': 
                    Day = 'Friday'
                    break;
                case '6': 
                    Day = 'Saturday'
                    break;
                default: break;
            }
            console.log(date)
            return this.T(Day)
        },
        Month() {
            let date = this.util.dateParse(Date.now(), 'MM-dd'),
                M = ''
            switch (~~date.split('-')[0]) {
                case 1:
                    M = 'January'
                    break;
                case 2:
                    M = 'February'
                    break;
                case 3:
                    M = 'March'
                    break;
                case 4:
                    M = 'April'
                    break;
                case 5:
                    M = 'May'
                    break;
                case 6:
                    M = 'June'
                    break;
                case 7:
                    M = 'July'
                    break;
                case 8:
                    M = 'August'
                    break;
                case 9:
                    M = 'September'
                    break;
                case 10:
                    M = 'October'
                    break;
                case 11:
                    M = 'November'
                    break;
                case 12:
                    M = 'December'
                    break;
                default: break;
            }
            return this.T(M)
        }
    },
    mounted() {
        setTimeout(() => {
            this.showText = true
        }, 500)
    }
}
</script>

<style lang="scss" scoped>
.date-com {
    padding-top: .4rem;
    text-align: center;
    text-shadow: 0 1px 0 $main-color;

    .over-hide {
        position: relative;
        height: .4rem;
        overflow: hidden;
    }
    
    .date-decorate {
        @include bgImg('date-decoration.png');
        width: 2.45rem;
        height: .2rem;
        margin: 0 auto;
    }

    .day {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -.4rem;
        text-align: center;
        font-size: $font-xl;
        transition: bottom .5s;

        &.show {
            bottom: 0;
        }
    }

    .date {
        position: absolute;
        left: 0;
        right: 0;
        top: -.4rem;
        text-align: center;
        font-size: $font-s;
        transition: top .5s;

        &.show {
            top: 0;
        }
    }
}
</style>